<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
            <el-form-item label-width="0" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20" placeholder="请输入专题名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('academic:special:special:add')" type="primary" size="small"
                           icon="el-icon-plus" @click="addColumn(0)">新增
                </el-button>
                <el-button v-if="hasPermission('academic:special:special:deleteColumn')" type="danger" size="small"
                           icon="el-icon-delete" @click="deleteColumn()">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="thematicName" label="专题名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="thematicState" label="状态" show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <div>状态
                            <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    content="启用后，还需要在【分类索引管理】中添加并公开，才能应用于资源。">
                                <i slot="reference" class="el-icon-question"></i>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.thematicState"
                                active-value="1"
                                @change="setType(row)"
                                inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column min-width="90px" fixed="right" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('academic:special:special:optResources')" type="text" size="small"
                                   @click="optResources(row)">关联资源
                        </el-button>
                        <el-button v-if="hasPermission('academic:special:special:edit')" type="text" size="small"
                                   @click="addColumn(2,row)">编辑
                        </el-button>
                        <el-button v-if="hasPermission('academic:special:special:deleteColumn')" type="text"
                                   size="small" @click="deleteColumn(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-special ref="addSpecial" @refresh="refreshList(1,1)"></add-special>
        <opt-resources ref="optResources"></opt-resources>
    </div>
</template>

<script>

import AddSpecial from "@/views/modules/academic/special/addSpecial.vue";
import OptResources from "@/views/modules/academic/optResources.vue";

export default {
    name: "divideList",
    components: {OptResources, AddSpecial},
    data() {
        return {
            searchForm: {
                name: '',
                current: 1,
                size: 20,
            },
            total: 0,

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.academic.thematicList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.thematicState = row.thematicState == 1 ? 0 : 1
            this.$axios(this.api.academic.thematicUpdateById, {
                id: row.id,
                thematicState: row.thematicState == 1 ? 0 : 1,
                thematicName: row.thematicName,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //0新增/2编辑按钮
        addColumn(num, row) {
            this.$refs.addSpecial.init(row)
        },

        //关联资源
        optResources(row){
            this.$refs.optResources.init(row,0)
        },

        //删除
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.thematicState == 1) {
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.thematicRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },


    },
}
</script>

<style scoped>
</style>
